module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/expand-arrows-1edf0bf2712418cdf05e5aaa00c1db02.svg";